import queryString from "query-string";
import config from "lib/fr-config";

// 나중에 복잡한 url 처리시 URLSearchParams 내부함수 사용하자.
// 나중에 복잡한 url 처리시 URLSearchParams 내부함수 사용하자.
// 나중에 복잡한 url 처리시 URLSearchParams 내부함수 사용하자.

const _getUrlInfo = url => {
  /**
   * https://a.com?page=1#main 입력시
   * originAndPathnameStr : "https://a.com"
   * searchStr : "?page=1"
   * hashStr : "#main"
   * 입력값이 비어있는 값이라면 각각 null 출력됨
   */
  const inputText = url || "";

  const rawUrlArr = inputText.split("#");
  const rawUrlPrefixArr = rawUrlArr[0].split("?");

  const originAndPathnameStr =
    rawUrlPrefixArr[0].length === 0 ? null : rawUrlPrefixArr[0];
  const searchStr = rawUrlPrefixArr[1] ? `?${rawUrlPrefixArr[1]}` : null;
  const hashStr = rawUrlArr[1] ? `#${rawUrlArr[1]}` : null;

  return { originAndPathnameStr, searchStr, hashStr };
};

const parseUrlString = url => {
  /**
   * _getUrlInfo 동일함수.
   */
  const { originAndPathnameStr: urlStr, searchStr, hashStr } = _getUrlInfo(url);
  return { urlStr, searchStr, hashStr };
};

const getQueryObjFromUrl = url => {
  /**
   * https://a.com?page=1&name=jo#main 입력시
   * { page: "1", name: "jo" } 출력
   * url의 쿼리부분 비어있다면 {} 출력
   * {},null 입력시 {} 출력
   */
  const { searchStr } = _getUrlInfo(url);
  return queryString.parse(searchStr);
};

const getQueryStringFromObj = queryObj => {
  /**
   * { page: "1", name: "jo" } 입력시
   * page=1&name=jo 출력
   * {},null 입력시 "" 출력
   */
  return queryString.stringify(queryObj);
};

const getFullUrl = ({ url, queryObj, hash }) => {
  /**
   * { url: "https://a.com?name=jo#main", queryObj: { page: "1" }, hash: "next" } 입력시
   * "https://a.com?name=jo&page=1#next" 출력
   * queryObj : null 아니라면 url에 queryObj를 "추가"함.
   * hash(#없이 단어만) : null 아니라면 url에 hash를 "교체"함.
   */
  const { originAndPathnameStr, searchStr, hashStr } = _getUrlInfo(url);

  if (!originAndPathnameStr) throw Error("null url");

  const oldQueryObj = getQueryObjFromUrl(searchStr);
  const newQueryObj = { ...oldQueryObj, ...queryObj };

  const rawSearchStr = getQueryStringFromObj(newQueryObj);
  const newSearchStr = !!rawSearchStr ? `?${rawSearchStr}` : "";

  const oldHashStr = !!hashStr ? hashStr : "";
  const newHashStr = !!hash ? `#${hash}` : `${oldHashStr}`;

  return `${originAndPathnameStr}${newSearchStr}${newHashStr}`;
};

const getEssentialUrl =
  ({ type, allowRefParam = false }) =>
  /**
   * 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수!
   * 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수!
   *
   * 이 함수 사용시 allowRefParam 변수 사용에 대해
   * 반드시 어떤 설정으로 사용할것인지 고려후 사용하자
   * (잘못 사용하면 레퍼럴 링크 쿼리정보가 특정 링크클릭시 사라지는 현상 발생된다.)
   *
   * 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수!
   * 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수! 필수!
   */
  /**
   * allowRefParam 값 true이면
   * 이전 페이지에서 레퍼런스 관련 쿼리값이 다음 링크에도 지속된다.
   */
  arg1 => {
    const URL = config.frontUrl;

    if (typeof URL[type] !== "function") throw Error("wrong type");

    const prefixURL = URL[type](arg1);

    if (!allowRefParam) return prefixURL;

    /**
     * 현 url에 레퍼럴 쿼리 파라메터가 있는경우 다음 url에도 전달하도록 하는 코드.
     */
    const REFERRAL_QUERY_INDEX = config.referralUrlQueryIndex;
    const REF_OUTFIT_QRY = REFERRAL_QUERY_INDEX.refOutfit;
    const REF_USERNAME_QRY = REFERRAL_QUERY_INDEX.refUsername;

    const params = new URLSearchParams(window.location.search);
    const query = [REF_USERNAME_QRY, REF_OUTFIT_QRY]
      .filter(key => params.has(key))
      .map(key => `${key}=${encodeURIComponent(params.get(key))}`)
      .join("&");

    return `${prefixURL}${query ? `?${query}` : ""}`;
  };

export {
  parseUrlString,
  getQueryObjFromUrl,
  getQueryStringFromObj,
  getFullUrl,
  getEssentialUrl
};
